import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GuardadosService {
  private readonly storageKey = 'productosGuardados';

  private readonly guardadosSignal = signal<string[]>(this.cargarDesdeLocalStorage());

  /** @deprecated Use guardadosSignal() directly in signal-based consumers */
  public guardados$: Observable<string[]> = toObservable(this.guardadosSignal);

  private cargarDesdeLocalStorage(): string[] {
    try {
      const guardadosJson = localStorage.getItem(this.storageKey);
      return guardadosJson ? JSON.parse(guardadosJson) : [];
    } catch {
      return [];
    }
  }

  private guardarEnLocalStorage(codigos: string[]): void {
    localStorage.setItem(this.storageKey, JSON.stringify(codigos));
  }

  getGuardados(): string[] {
    return this.guardadosSignal();
  }

  addProducto(codigo: string): void {
    const actuales = this.getGuardados();
    if (!actuales.includes(codigo)) {
      const nuevos = [...actuales, codigo];
      this.guardadosSignal.set(nuevos);
      this.guardarEnLocalStorage(nuevos);
    }
  }

  removeProducto(codigo: string): void {
    const actuales = this.getGuardados();
    const nuevos = actuales.filter(c => c !== codigo);
    this.guardadosSignal.set(nuevos);
    this.guardarEnLocalStorage(nuevos);
  }

  isGuardado(codigo: string): boolean {
    return this.getGuardados().includes(codigo);
  }
}
